"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var resolveAllUnresolvedRecipients_1 = require("./resolveAllUnresolvedRecipients");
var showHideFindResult_1 = require("./showHideFindResult");
var ReadWriteRecipientWellViewState_1 = require("../store/schema/ReadWriteRecipientWellViewState");
var legacy_1 = require("satcheljs/lib/legacy");
var owa_mail_subject_picker_store_1 = require("owa-mail-subject-picker-store");
var owa_mail_feature_flags_1 = require("owa-mail-feature-flags");
exports.default = legacy_1.action('addReadWriteRecipient')(function addReadWriteRecipient(recipientWell, isValid, newPersona, newEmailAddress, resetFindResult) {
    if (resetFindResult === void 0) { resetFindResult = true; }
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var newRecipient;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!newPersona) {
                        // construct the email address wrapper if it's not provided.
                        newPersona = {
                            EmailAddress: {
                                MailboxType: 'OneOff',
                                RoutingType: 'SMTP',
                                EmailAddress: newEmailAddress,
                                Name: newEmailAddress,
                            },
                        };
                    }
                    newRecipient = {
                        persona: newPersona,
                        displayText: newPersona.EmailAddress.Name
                            ? newPersona.EmailAddress.Name
                            : newPersona.EmailAddress.EmailAddress,
                        isValid: isValid,
                        isContextMenuOpen: false,
                        isSelected: false,
                        isExpanding: false,
                    };
                    recipientWell.recipients.push(newRecipient);
                    recipientWell.isDirty = true;
                    if (!resetFindResult) return [3 /*break*/, 2];
                    // Clear query string from input field.
                    recipientWell.queryString = '';
                    // Upon resolved, reset the Find Result
                    showHideFindResult_1.default(recipientWell, true /**shouldShowFindResult */, true /* shouldClearFindResult */);
                    // Reset the FindResultType
                    recipientWell.findResultType = ReadWriteRecipientWellViewState_1.FindRecipientResultType.None;
                    if (!recipientWell.inForceResolve) return [3 /*break*/, 2];
                    return [4 /*yield*/, resolveAllUnresolvedRecipients_1.default(recipientWell)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (owa_mail_feature_flags_1.isMailFeatureEnabled('peo-subjectPicker')) {
                        if (recipientWell.recipients.length === 1 && newRecipient.isValid) {
                            owa_mail_subject_picker_store_1.oneRecipientSelectedAction(newRecipient.persona);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    });
});
//# sourceMappingURL=addReadWriteRecipient.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-readwrite-recipient-well/lib/actions/addReadWriteRecipient.js
// module id = 2615
// module chunks = 2 3 4 45